<p>create-session works!</p>
